import { useMemo } from 'react';

import { isQuantityPromotionActive } from '@/shared/utils/quantity-promotion';
import { QUANTITY_PROMOTION_CHANNEL } from '@/modules/cart/hooks/use-cart-quantity-promotion';

import type { GetStoreItemsResponse, StoreItem } from '../types/get-store-items';
import {
  buildCategoryNameById,
  quantityPromotionProductNote,
} from '../utils/quantity-promotion-scope';

/**
 * Linha da página/drawer do produto (PRAT-184): "Promoção: 2º item com 50% —
 * vale para Hambúrguers". Null quando a loja não tem a promoção no app ou o
 * produto não participa (categoria de fora ou item excluído).
 */
export function useQuantityPromotionNote(
  storeItems: GetStoreItemsResponse | undefined,
  product: Pick<StoreItem, 'id' | 'category_id'> | null | undefined
): string | null {
  return useMemo(() => {
    const rule = storeItems?.quantity_promotion ?? null;
    if (!isQuantityPromotionActive(rule, QUANTITY_PROMOTION_CHANNEL)) return null;
    return quantityPromotionProductNote(rule, product, buildCategoryNameById(storeItems));
  }, [storeItems, product]);
}
